import {extend} from 'flarum/extend';
import IndexPage from 'flarum/components/IndexPage';

export default function () {
  // Remove sorting options
  extend(IndexPage.prototype, 'viewItems', function (items) {
    removeSortItems(items)
  });

  function removeSortItems(items) {
    const sortItemsToRemove = [
      app.translator.trans('core.forum.index_sort.newest_button')[0],
      app.translator.trans('core.forum.index_sort.top_button')[0],
      app.translator.trans('core.forum.index_sort.oldest_button')[0],
      app.translator.trans('core.forum.index_sort.unpopular_button')[0]
    ];
    items.items.sort.content.children = items.items.sort.content.children.filter(o => !sortItemsToRemove.includes(o.children[0]));
  }
}
